export const DRAG_DROP_LINE_BEFORE = 'drag-drop-line-before'
export const DRAG_DROP_LINE_AFTER = 'drag-drop-line-after'

const LINE_CLASSES = [DRAG_DROP_LINE_BEFORE, DRAG_DROP_LINE_AFTER]

export function clearTableRowDragIndicator(row) {
  const table = row?.closest?.('.ant-table')
  if (!table) return
  table.querySelectorAll('.ant-table-row').forEach((el) => {
    el.classList.remove(...LINE_CLASSES)
  })
}

export function updateTableRowDragIndicator(row, e) {
  if (!row) return
  clearTableRowDragIndicator(row)
  const rect = row.getBoundingClientRect()
  const cls = e.clientY < rect.top + rect.height / 2
    ? DRAG_DROP_LINE_BEFORE
    : DRAG_DROP_LINE_AFTER
  row.classList.add(cls)
}

export function getDropPositionFromRow(row) {
  if (row?.classList.contains(DRAG_DROP_LINE_AFTER)) return 'after'
  return 'before'
}

/** @returns {Array} new order; returns same reference if unchanged */
export function reorderRowsWithDropPosition(rows, fromIndex, targetIndex, position) {
  if (fromIndex === -1 || targetIndex === -1) return rows

  let newIndex = position === 'after' ? targetIndex + 1 : targetIndex
  const result = [...rows]
  const [moved] = result.splice(fromIndex, 1)

  if (fromIndex < newIndex) {
    const skipDecrement = position === 'before' && fromIndex < targetIndex
    if (!skipDecrement) newIndex -= 1
  }

  if (fromIndex === newIndex) return rows

  result.splice(newIndex, 0, moved)
  return result
}
